import React from 'react';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  }
}));


const FullLayout = (props) => {
  
  const classes = useStyles(); 

  return(
    <div className={classes.root}>
      {props.children}
    </div>
  )
}

export const withFullLayout = (Component) => {

  return () => {

    //const ComponentWithRouter = withRouter(Component)

    return (
      <FullLayout>
        <Component />
      </FullLayout>
    )
  }
}

export default FullLayout